import { MedicationUnit } from "@/types/__generated__/union-types"

const UNITS: Array<MedicationUnit> = ["PC", "ML", "MG", "GTT", "PUFF", "IU"]

const PRN_UNIT: MedicationUnit = "PRN"

export { UNITS, PRN_UNIT }
